/* eslint-disable no-nested-ternary */
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import React, { memo, useCallback, useEffect, useState } from "react";
import { Virtuoso } from "react-virtuoso";

import {
  Box,
  Checkbox,
  IconButton,
  ListItemText,
  MenuItem,
  Popover,
  TextField,
  Theme,
} from "@mui/material";

// import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SearchIcon from "@mui/icons-material/Search";

import { BasicButton } from "components/core/Button";
import { BasicTooltip } from "components/core/Tooltip";

const WrapperBox = styled(Box)({
  padding: "8px",
});

const CustomPopover = styled(Popover)({
  ".MuiPaper-root": {
    width: "320px",
  },
});

const useStyles = makeStyles((theme: Theme) => ({
  taskFilter: {
    "& .multiselect-container": {
      height: 400,
    },
    "& .optionContainer": {
      height: 355,
    },
  },
  filter: {
    color: theme.palette.primary.light,
    width: 23,
    height: 23,
  },
  selected: {
    color: theme.palette.primary.main,
  },
}));

export const EXPORT_MARKET_ACCESSOR = "exportMarket";
export const COUNTRY_CODE_LIST_ACCESSOR = "countryCodeList";
export const DC_LIST_ACCESSOR = "dcList";
export const BOM_ACCESSOR = "bom";
export const SKU_STATUS_ACCESSOR = "skuStatus";
export const STATUS_ACCESSOR = "status";
export const CONCEPT_ACCESSOR = "concept";
export const DEPT_ACCESSOR = "deptNum";
export const VENDOR_ACCESSOR = "vendorNum";
export const ACTION_CHANGE_LOG_ACCESSOR = "action";
export const CHANGE_TYPE_CHANGE_LOG_ACCESSOR = "changeType";

interface DefaultColumnFilterProps {
  renderFilter?: any;
  // header?: CustomHeader | undefined;
  customFilterDisabled?: boolean;
  column: any;
  onSearch?: (selected: string) => void;
}

function ColumnSearch({
  renderFilter,
  customFilterDisabled = false,
  column,
  onSearch,
}: DefaultColumnFilterProps) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);

  const [searchValue, setSearchValue] = useState("");
  const [searchApply, setSearchApply] = useState("");

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // const isNewOrAllSkuTable = [TableListTypeEnum.NewSku, TableListTypeEnum.AllSku]?.includes(
  //   tableType as TableListType,
  // );

  // console.log({ selected, id: column?.id, isCustomObjectKey, currentOptions, filterOptions });

  const handleClick = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleReset = () => {
    // setSelected([]);

    setSearchValue("");
    setSearchApply("");
    if (onSearch) onSearch("");
  };

  const handleSubmit = () => {
    // click to set selected fro refetching

    // pass to parent to fetch api
    if (onSearch) onSearch(searchValue);
    if (searchValue) setSearchApply(searchValue);

    setAnchorEl(null);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    setSearchValue(value);
  };

  // useEffect(() => {
  //   if (isReset) {
  //     setSelected([]);
  //   } else {
  //     setSelected(filterValue || []);
  //   }
  // }, [filterValue, isReset]);

  return (
    <Box display="flex" alignItems="center" className="wrapperFilter">
      <BasicTooltip title={`Filter ${column?.Header ? column?.Header : "list"}`}>
        <IconButton
          size="small"
          onClick={handleClick}
          sx={{
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: !searchApply ? "inherit" : "#E7F9F2",
            },
          }}
        >
          <SearchIcon style={{ color: !searchApply ? "inherit" : "#0DA16C" }} />
          {/* <FilterIconWrapper 
          active={!hasNoSelected}
          >
          </FilterIconWrapper> */}
        </IconButton>
      </BasicTooltip>

      <CustomPopover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setTimeout(() => {
            if (searchApply) {
              setSearchValue(searchApply);
            } else {
              setSearchValue("");
            }
          }, 500);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {renderFilter || (
          <>
            <WrapperBox>
              <TextField
                fullWidth
                placeholder="Search"
                name="search"
                value={searchValue}
                defaultValue={searchApply}
                onChange={handleSearchChange}
              />
            </WrapperBox>

            <WrapperBox>
              <BasicButton
                sx={{ marginBottom: "8px" }}
                fullWidth
                variant="contained"
                onClick={handleSubmit}
                disabled={!searchValue}
              >
                Search
              </BasicButton>

              <BasicButton
                fullWidth
                variant="outlined"
                onClick={handleReset}
                disabled={!searchValue}
              >
                Reset
              </BasicButton>
            </WrapperBox>
          </>
        )}
      </CustomPopover>
    </Box>
  );
}

export default memo(ColumnSearch);
